<template>
  <v-dialog v-model="value" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="text-h5"
          >{{ $t("User Profile")
          }}<span v-if="fullName.length > 1">: {{ fullName }}</span></span
        >
      </v-card-title>
      <v-card-text>
        <form-generator
          name="User Profile"
          ref="userProfile"
          :config="userProfileConfig"
          v-model="userProfile"
          :render="formRender"
          :lazy="false"
        >
          <v-card class="elevation-0">
            <v-card-subtitle class="blue-grey--text text--darken-4">{{
              $t("SETTINGS")
            }}</v-card-subtitle>
            <v-card-text>
              <div class="row py-0 my-0">
                <div class="col-12 py-0 my-0">
                  <v-slider
                    v-model="userProfile['fontSize']"
                    step="1"
                    ticks
                    :max="fontSize.max"
                    :min="fontSize.min"
                    :label="$t('Font Size')"
                    :value="
                      userProfile['fontSize']
                        ? userProfile['fontSize']
                        : fontSize
                    "
                    dense
                  >
                    <template v-slot:append>
                      <v-text-field
                        v-model="userProfile['fontSize']"
                        class="mt-0 pt-0 text-center"
                        hide-details
                        single-line
                        type="number"
                        style="width: 60px"
                        name="fontSize"
                        dense
                      ></v-text-field>
                    </template>
                  </v-slider>
                </div>
                <div class="col-12 py-0 my-0">
                  <v-select
                    :items="timeZoneOptions"
                    :label="$t('Time Zone')"
                    v-model="userProfile['userTimeZone']"
                    dense
                    name="timezone"
                  >
                  </v-select>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </form-generator>

        <!-- :submit="saveContact"
        <small>*indicates required field</small> -->
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="$emit('input', false)">
          Close
        </v-btn>
        <v-btn color="blue darken-1" text @click="saveProfile">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FormGenerator from "../../components/Contact/components/FormGeneratorRegular.vue";
import { dbProfiles } from "../../config/firebase";
export default {
  name: "userProfile",
  props: ["value"],
  data() {
    return {
      userProfileConfig: [
        //#region Contact Info
        {
          label: "Preferred Given Name(s)",
          type: "text",
          layout: "6",
          name: "preferred_firstName",
          options: "",
          required: "",
        },
        {
          label: "Preferred Family Name",
          type: "text",
          layout: "6",
          name: "preferred_lastName",
          options: "",
          required: "",
        },

        {
          label: "Pronouns",
          type: "select",
          layout: "",
          name: "Pronouns",
          options:
            "He/him/his, She/her/hers, They/them/theirs, Zie/Zir/Zirs, A pronoun not listed No pronoun preference",
          required: "",
        },
        {
          label: "App Role",
          type: "select",
          layout: "",
          name: "appRole",
          options: "Admin,Member,Subcriber",
          required: "",
          default: "Member",
        },
        {
          label: "Gender",
          type: "select",
          layout: "",
          name: "Gender",
          options: "Male,Female",
          required: "",
        },
        {
          label: "What is your Language Preference?",
          type: "select",
          layout: "",
          name: "What_is_your_Language_Preference?",
          options: "English,French",
          required: "",
        },
      ],
      userProfileDefault: {
        preferred_lastName: "Brian",
        preferred_firstName: "Edey",
        Gender: "Male",
        Email: "",
        Birth_Province: "Alberta",
        Address_Province: "73 Hawk Crescent",
        Phone_Number: "",
        Date_of_Birth: "1979-09-25",
        Passport_Given_Names: "Edey",
        Passport_Family_Name: "Brian John",
        Birth_Place: "Edmonton",
        Birth_Country: "Canada",
        Nationality_At_Birth: "Canada",
        Address_Line: "73 Hawk Crescent",
        Address_City: "Ottawa",
        Address_Country: "Canada",
        Address_Postcode: "K1V 9G8",
        Passport_No: "AG260610",
        Passport_Issued: "3/20/2018",
        Passport_Expiry: "3/20/2028",
        Passport_Country_of_Issue: "Canada",
        Passport_Country: "Canada",
        Passport_issuing_authority: "Canada",
        Passport_Scan: "",
        Accreditaion_Photo_File_Name: "",
        "What_is_your_Language_Preference?": "English",
        Pronouns: "He/Him/His",
        Phone_Type: "",
        Emergency_Contact_Name: "Meaghan Davis",
        Emergency_Contact_Relationship: "Wife",
        Emergency_Contact_Phone: "",
        Emergency_Contact_Email: "",
        Games: "Beijing 2022",
        "Disability Type": "",
        Waist: "36",
        Hips: "",
        Chest: "",
        Inseam: "",
        Shoe: "10",
        Height: "191",
      },
      userProfile: {},
      formRender: false,
      fontSize: {
        value: 16,
        min: 16,
        max: 26,
      },
      timezone: [
        {
          offset: "GMT-12:00",
          name: "Etc/GMT-12",
        },
        {
          offset: "GMT-11:00",
          name: "Etc/GMT-11",
        },
        {
          offset: "GMT-11:00",
          name: "Pacific/Midway",
        },
        {
          offset: "GMT-10:00",
          name: "America/Adak",
        },
        {
          offset: "GMT-09:00",
          name: "America/Anchorage",
        },
        {
          offset: "GMT-09:00",
          name: "Pacific/Gambier",
        },
        {
          offset: "GMT-08:00",
          name: "America/Dawson_Creek",
        },
        {
          offset: "GMT-08:00",
          name: "America/Ensenada",
        },
        {
          offset: "GMT-08:00",
          name: "America/Los_Angeles",
        },
        {
          offset: "GMT-07:00",
          name: "America/Chihuahua",
        },
        {
          offset: "GMT-07:00",
          name: "America/Denver",
        },
        {
          offset: "GMT-06:00",
          name: "America/Belize",
        },
        {
          offset: "GMT-06:00",
          name: "America/Cancun",
        },
        {
          offset: "GMT-06:00",
          name: "America/Chicago",
        },
        {
          offset: "GMT-06:00",
          name: "Chile/EasterIsland",
        },
        {
          offset: "GMT-05:00",
          name: "America/Bogota",
        },
        {
          offset: "GMT-05:00",
          name: "America/Havana",
        },
        {
          offset: "GMT-05:00",
          name: "America/New_York",
        },
        {
          offset: "GMT-04:30",
          name: "America/Caracas",
        },
        {
          offset: "GMT-04:00",
          name: "America/Campo_Grande",
        },
        {
          offset: "GMT-04:00",
          name: "America/Glace_Bay",
        },
        {
          offset: "GMT-04:00",
          name: "America/Goose_Bay",
        },
        {
          offset: "GMT-04:00",
          name: "America/Santiago",
        },
        {
          offset: "GMT-04:00",
          name: "America/La_Paz",
        },
        {
          offset: "GMT-03:00",
          name: "America/Argentina/Buenos_Aires",
        },
        {
          offset: "GMT-03:00",
          name: "America/Montevideo",
        },
        {
          offset: "GMT-03:00",
          name: "America/Araguaina",
        },
        {
          offset: "GMT-03:00",
          name: "America/Godthab",
        },
        {
          offset: "GMT-03:00",
          name: "America/Miquelon",
        },
        {
          offset: "GMT-03:00",
          name: "America/Sao_Paulo",
        },
        {
          offset: "GMT-03:30",
          name: "America/St_Johns",
        },
        {
          offset: "GMT-02:00",
          name: "America/Noronha",
        },
        {
          offset: "GMT-01:00",
          name: "Atlantic/Cape_Verde",
        },
        {
          offset: "GMT",
          name: "Europe/Belfast",
        },
        {
          offset: "GMT",
          name: "Africa/Abidjan",
        },
        {
          offset: "GMT",
          name: "Europe/Dublin",
        },
        {
          offset: "GMT",
          name: "Europe/Lisbon",
        },
        {
          offset: "GMT",
          name: "Europe/London",
        },
        {
          offset: "UTC",
          name: "UTC",
        },
        {
          offset: "GMT+01:00",
          name: "Africa/Algiers",
        },
        {
          offset: "GMT+01:00",
          name: "Africa/Windhoek",
        },
        {
          offset: "GMT+01:00",
          name: "Atlantic/Azores",
        },
        {
          offset: "GMT+01:00",
          name: "Atlantic/Stanley",
        },
        {
          offset: "GMT+01:00",
          name: "Europe/Amsterdam",
        },
        {
          offset: "GMT+01:00",
          name: "Europe/Belgrade",
        },
        {
          offset: "GMT+01:00",
          name: "Europe/Brussels",
        },
        {
          offset: "GMT+02:00",
          name: "Africa/Cairo",
        },
        {
          offset: "GMT+02:00",
          name: "Africa/Blantyre",
        },
        {
          offset: "GMT+02:00",
          name: "Asia/Beirut",
        },
        {
          offset: "GMT+02:00",
          name: "Asia/Damascus",
        },
        {
          offset: "GMT+02:00",
          name: "Asia/Gaza",
        },
        {
          offset: "GMT+02:00",
          name: "Asia/Jerusalem",
        },
        {
          offset: "GMT+03:00",
          name: "Africa/Addis_Ababa",
        },
        {
          offset: "GMT+03:00",
          name: "Asia/Riyadh89",
        },
        {
          offset: "GMT+03:00",
          name: "Europe/Minsk",
        },
        {
          offset: "GMT+03:30",
          name: "Asia/Tehran",
        },
        {
          offset: "GMT+04:00",
          name: "Asia/Dubai",
        },
        {
          offset: "GMT+04:00",
          name: "Asia/Yerevan",
        },
        {
          offset: "GMT+04:00",
          name: "Europe/Moscow",
        },
        {
          offset: "GMT+04:30",
          name: "Asia/Kabul",
        },
        {
          offset: "GMT+05:00",
          name: "Asia/Tashkent",
        },
        {
          offset: "GMT+05:30",
          name: "Asia/Kolkata",
        },
        {
          offset: "GMT+05:45",
          name: "Asia/Katmandu",
        },
        {
          offset: "GMT+06:00",
          name: "Asia/Dhaka",
        },
        {
          offset: "GMT+06:00",
          name: "Asia/Yekaterinburg",
        },
        {
          offset: "GMT+06:30",
          name: "Asia/Rangoon",
        },
        {
          offset: "GMT+07:00",
          name: "Asia/Bangkok",
        },
        {
          offset: "GMT+07:00",
          name: "Asia/Novosibirsk",
        },
        {
          offset: "GMT+08:00",
          name: "Etc/GMT+8",
        },
        {
          offset: "GMT+08:00",
          name: "Asia/Hong_Kong",
        },
        {
          offset: "GMT+08:00",
          name: "Asia/Krasnoyarsk",
        },
        {
          offset: "GMT+08:00",
          name: "Australia/Perth",
        },
        {
          offset: "GMT+08:45",
          name: "Australia/Eucla",
        },
        {
          offset: "GMT+09:00",
          name: "Asia/Irkutsk",
        },
        {
          offset: "GMT+09:00",
          name: "Asia/Seoul",
        },
        {
          offset: "GMT+09:00",
          name: "Asia/Tokyo",
        },
        {
          offset: "GMT+09:30",
          name: "Australia/Adelaide",
        },
        {
          offset: "GMT+09:30",
          name: "Australia/Darwin",
        },
        {
          offset: "GMT+09:30",
          name: "Pacific/Marquesas",
        },
        {
          offset: "GMT+10:00",
          name: "Etc/GMT+10",
        },
        {
          offset: "GMT+10:00",
          name: "Australia/Brisbane",
        },
        {
          offset: "GMT+10:00",
          name: "Australia/Hobart",
        },
        {
          offset: "GMT+10:00",
          name: "Asia/Yakutsk",
        },
        {
          offset: "GMT+10:30",
          name: "Australia/Lord_Howe",
        },
        {
          offset: "GMT+11:00",
          name: "Asia/Vladivostok",
        },
        {
          offset: "GMT+11:30",
          name: "Pacific/Norfolk",
        },
        {
          offset: "GMT+12:00",
          name: "Etc/GMT+12",
        },
        {
          offset: "GMT+12:00",
          name: "Asia/Anadyr",
        },
        {
          offset: "GMT+12:00",
          name: "Asia/Magadan",
        },
        {
          offset: "GMT+12:00",
          name: "Pacific/Auckland",
        },
        {
          offset: "GMT+12:45",
          name: "Pacific/Chatham",
        },
        {
          offset: "GMT+13:00",
          name: "Pacific/Tongatapu",
        },
        {
          offset: "GMT+14:00",
          name: "Pacific/Kiritimati",
        },
      ],
      userTimeZone: null,
    };
  },
  components: {
    FormGenerator,
  },
  computed: {
    timeZoneOptions() {
      return this.timezone.map((item) => item.name + " " + item.offset);
    },
    fullName() {
      let user = this.userProfile;
      if (user.preferred_firstName && user.preferred_lastName) {
        return user.preferred_firstName + " " + user.preferred_lastName;
      } else {
        return "";
      }
    },
  },
  watch: {
    value(newVal) {
      // if newVal = true profile dialog is open
      if (newVal) {
        this.$nextTick(() => {
          this.init();
        });
      } else {
        // reset user profile
        this.userProfile = {};
        this.formRender = false;
      }
    },
    "userProfile.fontSize": {
      immediate: true,
      handler() {
        // console.log("font", newVal);
        document.querySelector("html").style.fontSize =
          this.userProfile["fontSize"] + "px";
      },
    },
  },
  methods: {
    saveProfile() {
      let profile = this.$refs.userProfile.$el;
      let formData = new FormData(profile);
      let userProfile = this.userProfile;
      for (var key of formData.keys()) {
        userProfile[key] = formData.get(key);
      }
      // let config = {
      //   uid: "KhdCdVGzplYQy8Ccnf48jATMwXy1",
      //   profile_uid: "3oK7Lg6Cf767tSnjKpYS",
      //   preferred_lastName: "Juane",
      //   preferred_firstName: "Sonny",
      //   appRole: "Admin",
      //   Gender: "Male",
      //   "What_is_your_Language_Preference?": "English",
      //   Phone_Number: "6138527669",
      // };

      if (!userProfile.profile_uid) {
        let profileRef = dbProfiles.doc();
        userProfile["profile_uid"] = profileRef.id;
        profileRef
          .set(userProfile)
          .then(() => this.$app.alert("You profile has been saved"));
      } else {
        dbProfiles
          .doc(userProfile.profile_uid)
          .set(userProfile)
          .then(() => {
            console.log("Document successfully written!");
            this.$app.alert("You profile has been saved");
          });
      }
      this.closeDialog(1500);
      //this.$app.alert("You profile has been saved");
      //console.log("userProfile", userProfile, profile);
    },
    init() {
      this.formRender = true;
      this.userProfile = this.$app.user;
    },
    closeDialog(delay) {
      delay = delay ? delay : 0;

      setTimeout(() => {
        this.$emit("input", false);
      }, delay);
    },
    reRender() {},
  },
  mounted() {
    console.log("mounted");
  },
};
</script>

<style></style>
